// The phone Job Queue's station, remembered on this device (localStorage; the old phone page kept
// it in sessionStorage "mobileWorkstation", read once as a fallback). Used by the queue screen and
// the phone shell's station chip.
import { QUEUE_STATIONS } from "../utils/scanCodes";

const STATION_KEY = "jobq.phone.queueStation";

/** The remembered station, or null. */
export function readQueueStation() {
  try {
    const s = localStorage.getItem(STATION_KEY) || sessionStorage.getItem("mobileWorkstation");
    if (s && QUEUE_STATIONS.includes(s)) return s;
  } catch (e) { /* storage blocked */ }
  return null;
}

export function saveQueueStation(s) {
  try { localStorage.setItem(STATION_KEY, s); } catch (e) { /* storage blocked */ }
}
